// extracted by mini-css-extract-plugin
module.exports = {"tooltipContainer":"styles_tooltipContainer__Jl6h1","tooltipArrowContainer":"styles_tooltipArrowContainer__h9biJ","tooltipArrowElement":"styles_tooltipArrowElement__K37QG"};